module.exports = __webpack_public_path__ + "static/media/pptx.b804e49f.svg";